export const MODULE_NAME = 'user';

export const AGE_VALIDATION_SESSION_KEY = 'ageValidationBirth';
export const AGE_VALIDATION_AGE_SESSION_KEY = 'isOfAge';
